<template>
  <div
    v-if="customIsVisible"
    :class="[model.backgroundColor, model.bottomMargin, model.verticalPadding]"
    class="text-block"
  >
    <div class="mx-auto w-full max-w-screen-2xl px-5 md:px-12 block-content">
      <!-- Innovadis custom: use VcTypography for consistency-->
      <VcTypography :tag="model.heading" :anchor-id="model.title">
        {{ model.title }}
      </VcTypography>
      <div v-html-safe="contentValue" class="inline-flex flex-col text-lg mt-4"></div>
      <div v-if="model.buttons?.length" class="my-4 flex space-x-4">
        <InnoButton
          v-for="(item, index) in model.buttons"
          :key="index"
          v-bind="getLinkAttr(item.link)"
          class="flex-1 lg:flex-none"
          color="primary"
          :target="'externalLink' in getLinkAttr(item.link) ? '_blank' : '_self'"
          :variant="model.buttons.length > 1 && index === 0 ? 'solid' : 'outline'"
          shape="pill"
          size="lg"
        >
          {{ item.label }}
        </InnoButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { getLinkAttr } from "@/core/utilities/common";
import InnoButton from "@/ui-kit/components/molecules/innovadis/inno-button.vue";

// Innovadis custom
type ButtonType = {
  label: string;
  link: string;
};

export interface IProps {
  // Innovadis custom: Use custom visibility setting
  customIsVisible: boolean;

  model: {
    heading: string;
    title: string;
    text: string | { html: string };
    buttons?: Array<ButtonType>; // Innivadis custom

    // Innovadis custom: Use custom layout settings
    backgroundColor: string;
    bottomMargin: string;
    verticalPadding: string;
  };

  background?: string;
  settings: any;
}

const props = defineProps<IProps>();

const contentValue = computed(() => {
  return typeof props.model.text === "object" ? props.model.text?.html : props.model.text;
});
</script>
